import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserPlus } from "@phosphor-icons/react";

export default function InviteMemberForm({
  inviteEmail, setInviteEmail, inviteRole, setInviteRole, onSubmit,
}) {
  return (
    <form onSubmit={onSubmit} className="mt-8 border border-zinc-200 bg-white p-6" data-testid="invite-form">
      <div className="flex items-center gap-2 mb-4">
        <UserPlus size={20} />
        <div className="gf-overline">Invite a member</div>
      </div>
      <p className="text-xs text-zinc-500 mb-4 font-mono">
        The user must already have a GrantFlow account. They'll be added immediately.
      </p>
      <div className="grid md:grid-cols-3 gap-3">
        <div className="md:col-span-2">
          <Label className="gf-overline">Email</Label>
          <Input
            data-testid="invite-email"
            type="email"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            className="gf-sharp mt-2 border-zinc-300 bg-white"
            placeholder="member@org.com"
          />
        </div>
        <div>
          <Label className="gf-overline">Role</Label>
          <Select value={inviteRole} onValueChange={setInviteRole}>
            <SelectTrigger data-testid="invite-role" className="gf-sharp mt-2 border-zinc-300 bg-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="gf-sharp">
              <SelectItem value="member">Member</SelectItem>
              <SelectItem value="manager">Manager</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <Button
        type="submit"
        data-testid="invite-submit"
        className="gf-sharp mt-4 bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide"
      >
        Add member
      </Button>
    </form>
  );
}
